<template>
  <div id='' class='gPageBorder'>

    <el-form class='gForm' label-position="right" ref="channel" :rules='rules' label-width="12.5%" :model='channel' style=''>
      <el-form-item :label="$t('app_name')" prop='name'>
        <el-input v-model="channel.name" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_dParent')" prop='father'>
        <!--<el-select @change='cSelect'  v-model="channel.father" placeholder="" clearable>-->
          <!--<el-option-->
            <!--v-for="item in fatherList"-->
            <!--:label="item.name"-->
            <!--:value="item">-->
          <!--</el-option>-->
        <!--</el-select>-->
        <MechanismSelector  :data="mechanismData" :mselect="true"></MechanismSelector>
      </el-form-item>
      <el-form-item :label="$t('app_contact')" prop='contact'>
        <el-input v-model="channel.contact" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_contactPhone')" prop='tel'>
        <el-input v-model="channel.tel" placeholder=''></el-input>
      </el-form-item>
      <el-form-item :label="$t('app_addres')" prop='addr'>
        <el-input v-model="channel.addr" placeholder=''></el-input>
      </el-form-item>
      <el-form-item v-show="right === '0'" :label="$t('app_cerMgType')" prop=''>
        <!-- 编辑时是不能编辑 -->
        <span v-if='this.config.type === 1'>
          <!--disabled-->
          <el-radio   class="radio" v-model="radio" label="0">{{$t('app_cerMgSelf')}}</el-radio>
          <el-radio   class="radio" v-model="radio" label="1">{{$t('app_cerMgOther')}}</el-radio>
          <el-radio   class="radio" v-model="radio" label="2">{{$t('app_cerMgCustomer')}}</el-radio>
        </span>
        <span v-else>
          <!-- 新增的时候，如果不选到自己，是不能编辑 -->
          <!--disabled-->
          <span v-if="channel.father && channel.father.pid !== '0'">
            <el-radio  class="radio" v-model="radio" label="0">{{$t('app_cerMgSelf')}}</el-radio>
            <el-radio  class="radio" v-model="radio" label="1">{{$t('app_cerMgOther')}}</el-radio>
            <el-radio  class="radio" v-model="radio" label="2">{{$t('app_cerMgCustomer')}}</el-radio>
          </span>
          <span v-else>
            <el-radio  class="radio" v-model="radio" label="0">{{$t('app_cerMgSelf')}}</el-radio>
            <el-radio  class="radio" v-model="radio" label="1">{{$t('app_cerMgOther')}}</el-radio>
            <el-radio  class="radio" v-model="radio" label="2">{{$t('app_cerMgCustomer')}}</el-radio>
          </span>
        </span>
      </el-form-item>
      <!-- <el-form-item :label="$t('app_adRefreshfreq')" prop=''>
        <el-input-number v-model="channel.refresh"  :min="1" :max="1440" label="描述文字"></el-input-number>
        <label> {{$t('app_minute')}}</label>
      </el-form-item> -->
      <el-form-item>
        <el-button  type='' style='' @click="cancel">{{$t('app_cancel')}}</el-button>
        <el-button  type='primary' style='' :loading="loading" @click="save('channel')">{{$t('app_save')}}</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<style scoped>
  [v-cloak]{
    display: none;
  }
</style>

<script>
  import MechanismSelector from '@/components/global/mechanism_selector.vue'
  export default{
    components: {
      MechanismSelector
    },
    data () {
      var phoneCheck = (rule, value, callback) => {
        if (!this.isLegalMobile(value)) {
          callback(new Error(this.$t('app_phoneIllegal')));
        } else {
          callback()
        }
      }
			var ftCheck = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('app_input')));
        } else {
          callback()
        }
      }
      var that = this
      return {
//        config: {
//          pageType: 0,
//          type: 0,
//          data: ''
//        },
        channel: {
          name: '',
          father: '',
          contact: '',
          tel: '',
          // refresh: 1,
          addr: '',
          config: {
          }
        },
        mechanismData: '',
        rightEnable: false,
        right: 0,
        radio: '0',
        fatherList: [],
        loading: 0,
        rules: {
          name: [
            { required: true, message: this.$t('app_inputName'), trigger: 'blur' }
          ],
					father: [
            { required: true, message: this.$t('app_input'), trigger: 'blur',validator:ftCheck }
          ],
          contact: [
            { required: true, message: this.$t('app_inputContact'), trigger: 'blur' }
          ],
          tel: [
            { required: true, message: this.$t('app_inputTruePhone'), trigger: 'blur'/*, validator: phoneCheck*/}
          ],
          addr: [
            { required: true, message: this.$t('app_inputAddr'), trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      cSelect (vl) {
        this.radio = vl.certType + ''
      },
      isLegalMobile (tel) {
        var sMobile = tel
        var regex = "^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\\d{8}$"
        var re = new RegExp(regex, 'g')
        if(!(re.test(sMobile))){
          return false
        } else {
          return true
        }
      },
      newChannel () {
        this.loading = 1
        this.$addChannel(this.radio, this.channel.father.mechanismid, this.channel.father.mechanismgrade, this.channel.name, this.channel.addr, this.channel.contact, this.channel.tel, this.channel.father.mechanismname, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
          this.loading = 0
        })
      },
      editChannel () {
        var that = this
        var data = this.config.data
        // console.log(data)
//        that.mechanismData.value = data.superid
        // if (typeof(this.channel.father) === 'string') {
        //   this.channel.father = {grade: data.mechanismgrade, id: data.superid, name: data.memo}
        // }
        var fname = this.channel.father.mechanismname
        fname = fname?fname:''
        var fid = this.channel.father.mechanismid
        fid = fid?fid:''
        var fgrade = this.channel.father.mechanismgrade
        fgrade = fgrade?fgrade:''


        this.loading = 1
        this.$editChannel(this.radio, data.mechanismid, this.channel.name, fid, fgrade, this.channel.addr, fname, this.channel.contact, this.channel.tel, (res) => {
          this.loading = 0
          if (res.status === 200) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          this.loading = 0
        })
      },
      save (name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            
            if (this.config.type === 0) {
              this.newChannel()
            } else {
              this.editChannel()
            }
          } else {
            return false
          }
        })
      },
      cancel () {
        this.$router.go(-1)
      },
      getParents () {
        this.$parentChannel((res) => {
          // console.log(res)
          if (res.status === 200) {
            console.log("memeo...")
            console.log(res.data)
            this.fatherList = res.data
          } else {
            this.$message.error(res.message)
          }
        }, () => {
          // error
        })
      },
      fillData (data) {
        // console.log(data)

        var that = this

        this.channel.name = data.mechanismname
        this.channel.father = data.superid
        this.channel.contact = data.completename
        this.channel.tel = data.mechanismcode
        this.channel.addr = data.mechanismaddre
        // this.channel.refresh = data.refresh
        that.radio = data.certType + ''
        this.channel.father = {
          mechanismgrade: (parseInt(data.mechanismgrade) - 1).toString(),
          mechanismid: data.superid,
          mechanismname: data.memo
        }


      }
    },
    mounted () {
      var that = this
      this.right = localStorage.userType      
      // this.getParents()
      this.config = this.$getWObj().editDataConfig
      if (this.config.type === 1) {
        //// edit
        this.$getMcDetail(this.config.data.mechanismid, res => {
          var data = res.data
          that.mechanismData = {
            value: data.memo,
            callback (value, obj) {
              that.channel.father = obj
              // that.cSelect()
            }
          }
          // that.radio = this.config.data.certType
          this.fillData(data)
        }, '') 
      } else {
        //// new
        that.mechanismData = {
          callback (value, obj) {
            that.channel.father = obj
            // that.cSelect(obj)
          }
        }
      }
  
      
    }
  }
</script>



// WEBPACK FOOTER //
// newChannel.vue?11aa7d27